<template>
    <div>

        <el-row style="margin-bottom:10px;">
            <el-col :span="18" class='flex'>
                <el-select v-model='theYmwContentType' clearable @change="theYmwContentTypeChange" size='small'
                    style="max-width:130px;">
                    <el-option label="没有答案" :value="1"></el-option>
                    <el-option label="单一答案" :value="2"></el-option>
                    <el-option label="多种答案" :value="3"></el-option>
                </el-select>
                <el-select v-model='theYmwTyped' clearable @change="theYmwTypedChange" size='small'
                    style="max-width:130px;">
                    <el-option label="常规" :value="1"></el-option>
                    <el-option label="多选问答" :value="2"></el-option>
                    <el-option label="没有听懂" :value="3"></el-option>
                </el-select>
                <el-select v-model='theYmwgId' clearable @change="theYmwgIdChange" size='small'
                    style="max-width:130px;">
                    <el-option v-for="item in getMicrolectureWareGroupList_data.data || []" :key="item.ymwgId"
                        :label="item.ymwgName" :value="item.ymwgId">
                    </el-option>
                </el-select>
                <el-input v-model="getMicrolectureWareList_data.ymwCode" placeholder="请输入编号" clearable size='small'
                    style="max-width:130px;" />
                <el-input v-model="getMicrolectureWareList_data.ymwQuestion" placeholder="请输入问题" clearable size='small'
                    style="max-width:130px;" />
                <el-button v-click.getMicrolectureWareList type="primary" icon='el-icon-search' size='small'
                    style='margin-left:10px;'>搜索
                </el-button>
                <el-button @click=" $form('uploadMicrolectureWareVideoMultiAnswer'), bulkData = [], row = {}"
                    size='mini' type="primary" style="margin-left: 10px;" icon='el-icon-circle-plus'>批量导入回答视频
                </el-button>
                <el-button @click=" $form('uploadMicrolectureWareVideoMultiQuestion'), bulkDataTwo = [], row = {}"
                    size='mini' type="primary" style="margin-left: 10px;" icon='el-icon-circle-plus'>批量导入问题视频
                </el-button>
                <el-button @click=" $form('uploadMicrolectureWare'), tabledataAll = [], row = {}" size='mini'
                    type="primary" style="margin-left: 10px;" icon='el-icon-circle-plus'>批量导入回答和问题
                </el-button>
            </el-col>
            <el-col :span="6">
                <el-button v-if="addMicrolectureWare" @click=" $form('addMicrolectureWare')" size='small' type="primary"
                    style="float:right" icon='el-icon-circle-plus'>添加视频库
                </el-button>
            </el-col>
        </el-row>
        <mytable :tableColums='tableColums_getMicrolectureWareList' api='getMicrolectureWareList'
            xupdateapi='updateMicrolectureWare' :height="H - 165">
        </mytable>
        <myform :viewobj='{
                addMicrolectureWare: ["新增微课段落信息", "el-icon-circle-plus"],
                updateMicrolectureWare: ["修改微课段落信息", "el-icon-edit-outline"],
            }' @closed="$form('updateMicrolectureWare', 'reset');
            window.sleep(50, v => Myformdata && getMicrolectureWareList())" @confirm='myforms'>
            <template v-slot:ymwgId="{ Myformdata }">
                <el-select v-model='Myformdata.ymwgId' clearable>
                    <el-option v-for="item in getMicrolectureWareGroupList_data.data || []" :key="item.ymwgId"
                        :label="item.ymwgName" :value="item.ymwgId">
                    </el-option>
                </el-select>
            </template>
            <template v-slot:ymwThreeId="{ Myformdata }">
                <el-select v-model='Myformdata.ymwThreeId' clearable >
                    <el-option v-for="item in getMicrolectureWareListTwo_data.data || []" :key="item.ymwId"
                        :label="item.ymwCode" :value="item.ymwId">
                    </el-option>
                </el-select>
            </template>
            <template v-slot:ymwType="{ Myformdata }">
                <el-select v-model='Myformdata.ymwType' clearable>
                    <el-option label="常规" :value="1"></el-option>
                    <el-option label="多选问答" :value="2"></el-option>
                    <el-option label="没有听懂" :value="3"></el-option>
                </el-select>
            </template>
            <hide slot='ympId' />
            <hide slot='ymwId' />
            <template v-slot:ymwVideo='{ Myformdata }'>
                <myupload v-event.fileUpload='`
                      return (Myformdata.ymwVideo+"").startsWith("http") 
                || ( (C = (await C.MyUpload()).file) ? Myformdata.ymwVideo = C : false )
            `' @change='Myformdata.ymwVideo = ($file$ = arguments[0]).url'
                    @remove='window.sleep(150, v => Myformdata.ymwVideo = "")' type='video' :limit='1'
                    :params='{ file: "$file$" }' :filelist="Myformdata.ymwVideo && Myformdata.ymwVideo != ' '
                ? ({ name: Myformdata.ymwVideo, url: Myformdata.ymwVideo })
                : false
                " videoStyle="max-height:300px;"
                    x:style="{height: $form('updateMicrolecture','ifshow') ? '250px' : ''}">
                </myupload>

            </template>
            <template v-slot:ymwVideoMore='{ Myformdata }'>
                <myupload v-event.fileUpload='`
                      return (Myformdata.ymwVideoMore+"").startsWith("http") 
                || ( (C = (await C.MyUpload()).file) ? Myformdata.ymwVideoMore = C : false )
            `' @change='Myformdata.ymwVideoMore = ($file$ = arguments[0]).url'
                    @remove='window.sleep(150, v => Myformdata.ymwVideoMore = "")' type='video' :limit='1'
                    :params='{ file: "$file$" }' :filelist="Myformdata.ymwVideoMore && Myformdata.ymwVideoMore != ' '
                ? ({ name: Myformdata.ymwVideoMore, url: Myformdata.ymwVideoMore })
                : false
                " videoStyle="max-height:300px;"
                    x:style="{height: $form('updateMicrolecture','ifshow') ? '250px' : ''}">
                </myupload>

            </template>

            <template v-slot:ymwContentType="{ Myformdata }">
                <el-select v-model='Myformdata.ymwContentType' clearable>
                    <el-option label="没有答案" :value="1"></el-option>
                    <el-option label="单一答案" :value="2"></el-option>
                    <el-option label="多种答案" :value="3"></el-option>
                </el-select>
            </template>
            <template v-slot:ymwContentVideo='{ Myformdata }'>
                <myupload v-event.fileUpload='`
                      return (Myformdata.ymwContentVideo+"").startsWith("http") 
                || ( (C = (await C.MyUpload()).file) ? Myformdata.ymwContentVideo = C : false )
            `' @change='Myformdata.ymwContentVideo = ($file$ = arguments[0]).url'
                    @remove='window.sleep(150, v => Myformdata.ymwContentVideo = "")' type='video' :limit='1'
                    :params='{ file: "$file$" }' :filelist="Myformdata.ymwContentVideo && Myformdata.ymwContentVideo != ' '
                ? ({ name: Myformdata.ymwContentVideo, url: Myformdata.ymwContentVideo })
                : false
                " videoStyle="max-height:300px;"
                    x:style="{height: $form('updateMicrolecture','ifshow') ? '250px' : ''}">
                </myupload>

            </template>
            <template v-slot:ymwContent="{ Myformdata }">
                <el-input v-model='Myformdata.ymwContent' type="textarea" :rows="4"
                    placeholder="请输入内容(多选问答以&&&隔开)(如果一个问题多个答案也以&&&隔开)"></el-input>
            </template>
            <template v-slot:ymwQuestion="{ Myformdata }">
                <el-input v-model='Myformdata.ymwQuestion' type="textarea" :rows="4" placeholder="请输入问题"></el-input>
            </template>
        </myform>
        <myform view.uploadMicrolectureWareVideoMultiAnswer="批量上传"
            @close='$form("uploadMicrolectureWareVideoMultiAnswer", "hide"), getMicrolectureWareList()'>
            <el-row>
                <el-col :span="8">
                    <el-upload class="upload-demo" action="#" accept=".MP4," :on-change="updatabulkVideo"
                        :auto-upload="false" :show-file-list="false" ref="upload" multiple>
                        <el-button size="medium" type="danger">点击选取视频</el-button>
                    </el-upload>
                </el-col>
                <el-col :span="16" style="min-width:100px;">
                    <el-button type="primary" @click="submitUpload(1)">上传</el-button>
                </el-col>
            </el-row>
            <div v-if="fileList.length > 0" style="margin:10px 15px ;color:darkgreen">已选取 <span>{{ fileList.length
                    }}</span>
            </div>
            <div v-if="bulkData.length != 0" style="max-height: 600px;margin-top: 15px;">
                <el-table ref="bulkTable" :data="bulkData" stripe border style="width: 100%" max-height="500px"
                    :cell-style="{ textAlign: 'center' }" :header-cell-style="{
                textAlign: 'center',
                background: 'rgba(0,170,255,0.5)',
                color: 'black',
                border: 'none',
            }">
                    <el-table-column prop="status" label="状态" fixed="left" :filters="TemstrongArr"
                        :filter-method="filterTag" filter-placement="bottom-end">
                    </el-table-column>
                    <el-table-column prop="statusMsg" label="状态备注" fixed="left">
                    </el-table-column>
                    <el-table-column prop="fileName" label="文件名字" fixed="left">
                    </el-table-column>
                </el-table>
            </div>
            <div style="margin: 10px; font-size: 18px" v-if="bulkData.length != 0">
                <span style="color: #0080ff">一共{{ importData.numAll }}条;</span>
                <span style="color: #0e9a00; margin-left: 5px">成功{{ importData.numSuccess }}条;</span>
                <span style="color: red; margin-left: 5px">失败{{ importData.numFail }}条</span>
                <span style="color: #E6A23C; margin-left: 5px">信息不完整{{ importData.numUnWhole }}条</span>
            </div>
        </myform>
        <myform view.uploadMicrolectureWareVideoMultiQuestion="批量上传"
            @close='$form("uploadMicrolectureWareVideoMultiQuestion", "hide"), getMicrolectureWareList()'>
            <el-row>
                <el-col :span="8">
                    <el-upload class="upload-demo" action="#" accept=".MP4," :on-change="updatabulkVideo2"
                        :auto-upload="false" :show-file-list="false" ref="upload2" multiple>
                        <el-button size="medium" type="danger">点击选取视频</el-button>
                    </el-upload>
                </el-col>
                <el-col :span="16" style="min-width:100px;">
                    <el-button type="primary" @click="submitUpload(2)">上传</el-button>
                </el-col>
            </el-row>
            <div v-if="fileListTwo.length > 0" style="margin:10px 15px ;color:darkgreen">已选取 <span>{{ fileListTwo.length
                    }}</span>
            </div>
            <div v-if="bulkDataTwo.length != 0" style="max-height: 600px;margin-top: 15px;">
                <el-table ref="bulkTable" :data="bulkDataTwo" stripe border style="width: 100%" max-height="500px"
                    :cell-style="{ textAlign: 'center' }" :header-cell-style="{
                textAlign: 'center',
                background: 'rgba(0,170,255,0.5)',
                color: 'black',
                border: 'none',
            }">
                    <el-table-column prop="status" label="状态" fixed="left" :filters="TemstrongArr2"
                        :filter-method="filterTag" filter-placement="bottom-end">
                    </el-table-column>
                    <el-table-column prop="statusMsg" label="状态备注" fixed="left">
                    </el-table-column>
                    <el-table-column prop="fileName" label="文件名字" fixed="left">
                    </el-table-column>
                </el-table>
            </div>
            <div style="margin: 10px; font-size: 18px" v-if="bulkDataTwo.length != 0">
                <span style="color: #0080ff">一共{{ importDataTwo.numAll }}条;</span>
                <span style="color: #0e9a00; margin-left: 5px">成功{{ importDataTwo.numSuccess }}条;</span>
                <span style="color: red; margin-left: 5px">失败{{ importDataTwo.numFail }}条</span>
                <span style="color: #E6A23C; margin-left: 5px">信息不完整{{ importDataTwo.numUnWhole }}条</span>
            </div>
        </myform>
        <myform view.uploadMicrolectureWare="批量导入"
            @close='$form("uploadMicrolectureWare", "hide"), getMicrolectureWareList()'>
            <el-row>
                <el-col :span="4" style="min-width:100px;">
                    <el-button type="primary" @click="toDownExcel">下载<i
                            class="el-icon-download el-icon--right"></i></el-button>
                </el-col>
                <el-col :span="20">
                    <el-upload ref="uploadAll" action="#" :limit="1" :auto-upload="false" :show-file-list="true"
                        :on-change="onChangeContent">
                        <el-button type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button>
                    </el-upload>
                </el-col>
            </el-row>
            <el-table :data="tabledataAll" v-if="(tabledataAll || '').length > 0" max-height="400">
                <el-table-column prop="status" label="状态" width="120">
                </el-table-column>
                <el-table-column prop="statusMsg" label="原因" width="120">
                </el-table-column>
                <el-table-column prop="ymwCode" label="编号">
                </el-table-column>
                <el-table-column prop="ymwContent" label="回答内容">
                </el-table-column>
                <el-table-column prop="ymwQuestion" label="问题内容">
                </el-table-column>
            </el-table>
            <div style="margin: 10px; font-size: 18px" v-if="tabledataAll.length != 0">
                <span style="color: #0080ff">一共{{ tabledataAllimportData.numAll }}条;</span>
                <span style="color: #0e9a00; margin-left: 5px">成功{{ tabledataAllimportData.numSuccess }}条;</span>
                <span style="color: red; margin-left: 5px">失败{{ tabledataAllimportData.numFail }}条</span>
                <span style="color: #E6A23C; margin-left: 5px">信息不完整{{ tabledataAllimportData.numUnWhole }}条</span>
            </div>
            <div style="width:100%; margin: 60px auto 20px;text-align: right;">
                <!-- <el-button @click="bulkImportClose">取 消</el-button> -->
                <el-button type="success" @click="bulkImportClick">确定导入</el-button>
            </div>
        </myform>
        <el-dialog title="段落详情" :visible.sync="isParagraph" width="80%" :before-close="isParagraphClose">
            <el-descriptions v-if="ParagraphDetail" :column="2" border :labelStyle="{
                color: '#409EFF',
                textAlign: 'center',
                width: '20%',
                fontSize: '12px'
            }" :contentStyle="{ textAlign: 'left', width: '30%', fontSize: '12px' }">
              <el-descriptions-item label="编号">{{ ParagraphDetail.ymwCode }}</el-descriptions-item>
              <el-descriptions-item label="描述">{{ ParagraphDetail.ymwDes }}</el-descriptions-item>
                <el-descriptions-item label="段落类型">{{ ParagraphDetail.ymwType == 1 ? '常规' : ParagraphDetail.ymwType == 3 ? '没有听懂' :'多选问答'
                    }}</el-descriptions-item>
                <el-descriptions-item label="多选问答匹配度">{{ ParagraphDetail.ymwTypeTwoPass }}</el-descriptions-item>
                <el-descriptions-item label="没有听懂通过匹配度">{{ ParagraphDetail.ymwTypeThreePass }}</el-descriptions-item>
                <el-descriptions-item label="没有听懂段落编码">{{ ParagraphDetail.ymwThreeCode }}</el-descriptions-item>
                <el-descriptions-item label="没有听懂段落视频">
                    <video width="250" height="150" controls v-if="ParagraphDetail.ymwThreeVideo" :src="ParagraphDetail.ymwThreeVideo">
                        <!-- <source :src="ParagraphDetail.ymwThreeVideo" type="video/mp4">
                        您的浏览器不支持视频标签。 -->
                    </video>
                </el-descriptions-item>
                <el-descriptions-item label="排序">{{ ParagraphDetail.ymwOrder }}</el-descriptions-item>
                <el-descriptions-item label="问题">{{ ParagraphDetail.ymwQuestion }}</el-descriptions-item>
                <el-descriptions-item label="视频路径">
                    <video width="250" height="150" controls v-if="ParagraphDetail.ymwVideo" :src="ParagraphDetail.ymwVideo">
                        <!-- <source :src="ParagraphDetail.ymwVideo" type="video/mp4">
                        您的浏览器不支持视频标签。 -->
                    </video>
                </el-descriptions-item>
                <el-descriptions-item label="多选问答需要的旁白">
                    <video width="250" height="150" controls v-if="ParagraphDetail.ymwVideoMore" :src="ParagraphDetail.ymwVideoMore">
                        <!-- <source :src="ParagraphDetail.ymwVideoMore" type="video/mp4">
                        您的浏览器不支持视频标签。 -->
                    </video>
                </el-descriptions-item>
                <el-descriptions-item label="答案类型">{{ ParagraphDetail.ymwContentType == 1 ? '没有答案' :
                ParagraphDetail.ymwContentType
                    ==
                    2 ? '单一答案' : '多种问答' }}</el-descriptions-item>
                <el-descriptions-item label="内容">{{ ParagraphDetail.ymwContent }}</el-descriptions-item>
                <el-descriptions-item label="内容视频">
                    <video width="250" height="150" controls v-if="ParagraphDetail.ymwContentVideo" :src="ParagraphDetail.ymwContentVideo">
                        <!-- <source :src="ParagraphDetail.ymwContentVideo" type="video/mp4">
                        您的浏览器不支持视频标签。 -->
                    </video>
                </el-descriptions-item>
                <el-descriptions-item label="关键词">{{ ParagraphDetail.ymwKeyword }}</el-descriptions-item>
            </el-descriptions>
        </el-dialog>
    </div>
</template>

<script>
import myhttp from '../../utils/myhttp';
import qs from 'qs';
import axios from 'axios';
export default {
    data() {
        return {
            ParagraphDetail: '',
            isParagraph: false,
            theYmwContentType: '',
            tabledataAllimportData: [],
            tabledataAll: [],
            tabledata: [],
            bulkData: [],
            importData: [],
            bulkDataTwo: [],
            importDataTwo: [],
            TemstrongArr: [],
            TemstrongArr2: [],
            fileList: '',
            fileListTwo: '',
            theYmwTyped: '',
            theYmwgId: '',
            mainType: [],
            mtId: null,
            theMtId: "",
            getMicrolectureTypeMainList_data: [],
            tableColums_getMicrolectureWareList: {
                $selection: false,

                ymwCode: ['编号', 100,],
                ymwgName: ['视频库分组', 100,],
                ymwType: ['基础类型',90 , '@v-if: 1:常规 #(--Themecolor), 2:多选问答 #danger ,3:没有听懂 #danger'],
                ymwContentType: ['回答类型', 90, '@v-if: 1:没有答案 #danger, 2:单一答案,  3:多答案 #danger'],
                ymwQuestion: ['问题', ,],
                ymwContent: ['回答内容', ,],
                ymwTypeThreePass: ['匹配度',90,],
                ymwThreeCode: ['没听懂编码',100,],
                ymwOrder: ['排序',60,],
                createtime: ['创建时间',160,],

                $operation: [
                    '操作', 140,
                    this.updateMicrolectureWare && `@text: 详情#success
             @click:ParagraphDetails($row)
            `,
                    this.updateMicrolectureWare && `@text: 编辑#warn
             @click: $form("updateMicrolectureWare",$row)
            `,
                    this.deleteMicrolectureWare && `@text: 删除#danger
             @click: _confirm('确定要删除该微课吗?')
                     .trigger('deleteMicrolectureWare',{ymwId:$row.ymwId})
                     .trigger('getMicrolectureWareList')
            `,
                ],

            },

        };
    },

    watch: {

    },

    methods: {
        ParagraphDetails(data) {
            this.getMicrolectureWareDetails({ ymwId: data.ymwId }).result(res => {
                if (res.data.data) {
                    this.ParagraphDetail = res.data.data;
                    this.isParagraph = true;
                }
            })
        },
        isParagraphClose() {
            this.isParagraph = false;
        },
        theYmwContentTypeChange(e) {
            this.theYmwContentType = e
            this.getMicrolectureWareList({ ymwType: this.theYmwType, ymwgId: this.theYmwgId, ymwContentType: e })
        },
        bulkImportClick() {
            if (this.tabledata.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                this.uploadMicrolectureWare({
                    sitId: this.tabledata.sitId
                })
                this.$message({
                    type: 'success',
                    message: '导入成功!'
                });
                this.$refs.uploadAll.clearFiles();
                this.$form("uploadMicrolectureWare", "hide");
                this.getMicrolectureWareList()
            }

        },
        toDownExcel() {
            myhttp.downloadFile("https://trainapp.aojuai.com/trainai/excel/uploadMicrolectureWare.xlsx", "uploadMicrolectureWare.xlsx");
        },
        doupload: async function (file) {
            let param = new FormData(); // 创建form对象
            param.append("file", file);
            if (this.row && this.row.projectId) {
                param.append("projectId", this.row.projectId);
            }
            console.log(param)
            const loading = $Loading();
            const responseData = await myhttp.postFileUsers("/opportunity/microlecture-ware/uploadMicrolectureWare", param);
            loading.close();
            if (responseData.data.result == "success") {
                this.$message({
                    type: "success",
                    message: "上传成功!"
                });
            } else {
                this.$message({
                    type: "error",
                    message: responseData.data.msg
                });
            }
            return responseData
        },
        async onChangeContent(files, fileList) {
            const table = await this.doupload(files.raw);
            console.log(table);
            this.tabledata = table.data.data.sysImportTem;
            this.tabledataAll = table.data.data.resultList;
            this.tabledataAllimportData = table.data.data.importData;
            if (this.$refs.upload) {
                this.$refs.upload.clearFiles();  //清空文件
            }
            if (this.$refs.upload2) {
                this.$refs.upload2.clearFiles();  //清空文件
            }
        },
        filterTag(value, row) {
            return row.status == value;
        },
        filterTag2(value, row) {
            return row.status == value;
        },
        async submitUpload(val) {
            this.TemstrongArr = [];
            this.TemstrongArr2 = [];
            if (val == 1) {
                if (this.fileList == '') {
                    this.$message.error('请先选取文件,然后在上传!');
                    return
                }
                let param = new FormData()
                this.fileList.forEach(item => {
                    param.append('files', item.raw)
                })
                const loading = $Loading();
                const responseData = await myhttp.postFileUsers("/opportunity/microlecture-ware/uploadMicrolectureWareVideoMultiAnswer", param);
                loading.close();
                if (responseData.data.result == "success") {
                    this.$message({
                        type: "success",
                        message: "上传成功!"
                    });
                    this.bulkData = responseData.data.data.resultList;
                    this.importData = responseData.data.data.importData;
                    this.fileList = ''
                    this.$refs.upload.clearFiles();
                    if (responseData.data.data.importData.numSuccess > 0) {
                        this.TemstrongArr.push({ text: '成功', value: '成功' })
                    }
                    if (responseData.data.data.importData.numFail > 0) {
                        this.TemstrongArr.push({ text: '失败', value: '失败' })
                    }
                    if (responseData.data.data.importData.numUnWhole > 0 || responseData.data.data.importData.numUnWhole != null) {
                        this.TemstrongArr.push({ text: '信息不完整', value: '信息不完整' })
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: responseData.data.msg
                    });
                }
            } else {
                if (this.fileListTwo == '') {
                    this.$message.error('请先选取文件,然后在上传!');
                    return
                }
                let param = new FormData()
                this.fileListTwo.forEach(item => {
                    param.append('files', item.raw)
                })
                const loading = $Loading();
                const responseData = await myhttp.postFileUsers("/opportunity/microlecture-ware/uploadMicrolectureWareVideoMultiQuestion", param);
                loading.close();
                if (responseData.data.result == "success") {
                    this.$message({
                        type: "success",
                        message: "上传成功!"
                    });
                    this.bulkDataTwo = responseData.data.data.resultList;
                    this.importDataTwo = responseData.data.data.importData;
                    this.fileListTwo = ''
                    this.$refs.upload2.clearFiles();
                    if (responseData.data.data.importData.numSuccess > 0) {
                        this.TemstrongArr2.push({ text: '成功', value: '成功' })
                    }
                    if (responseData.data.data.importData.numFail > 0) {
                        this.TemstrongArr2.push({ text: '失败', value: '失败' })
                    }
                    if (responseData.data.data.importData.numUnWhole > 0 || responseData.data.data.importData.numUnWhole != null) {
                        this.TemstrongArr2.push({ text: '信息不完整', value: '信息不完整' })
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: responseData.data.msg
                    });
                }
            }
        },
        async updatabulkVideo(file, fileList, val) {
            let existFile = fileList.slice(0, fileList.length - 1).find(f => f.name === file.name);
            if (existFile) {
                this.$message.error('当前视频已经存在!');
                fileList.pop();
            }
            this.fileList = fileList;
        },
        async updatabulkVideo2(file, fileList, val) {
            let existFile = fileList.slice(0, fileList.length - 1).find(f => f.name === file.name);
            if (existFile) {
                this.$message.error('当前视频已经存在!');
                fileList.pop();
            }
            this.fileListTwo = fileList;
        },
        theYmwTypedChange(e) {
            this.theYmwTyped = e
            this.getMicrolectureWareList({ ymwType: e, ymwgId: this.theYmwgId })
        },
        theYmwgIdChange(e) {
            this.theYmwgId = e
            this.getMicrolectureWareList({ ymwgId: e, ymwType: this.theYmwTyped })
        },
        async subs(submit) {
            console.log(this.Myformdata);
            submit();
        },
        async myforms(submit, Myformdata) {
            const res = await this.$trigger("fileUpload").trigger(res => res && this.subs(submit))
        },
    },

    async created() {
        this.getMicrolectureWareGroupList({ pageSize: 0 });
        this.getMicrolectureWareList();
        this.getMicrolectureWareListTwo({ pageSize: 0,ymwType:3 });
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/bussiness/videoBank.vue